import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpLinkComponent from './adpLink.component';

let adpLinkModule = angular.module('adpLink', [
  uiRouter
])

.component('adpLink', adpLinkComponent)

.name;

export default adpLinkModule;



// WEBPACK FOOTER //
// ./src/app/components/adpLink/adpLink.js